import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "form", "inputGroup", "group" ]

  connect() {
    this.dropdown = document.querySelector(".dropdown-languages")
  }

  toggle(event) {
    event.preventDefault()

    if(this.inputHasValue()) {
      this.formTarget.submit()
    } else {
      this.toggleInput()
    }
  }

  inputHasValue() {
    return this.inputTarget.value.trim()
  }

  toggleInput() {
    this.inputTarget.classList.toggle("expanded")
    this.inputTarget.classList.toggle("collapsed")

    this.groupTarget.classList.toggle("group-expanded")
    this.groupTarget.classList.toggle("group-collapsed")

    if (this.inputTarget.classList.contains("expanded")) {
      this.inputTarget.focus()
    }

     this.updateLanguageDropdownVisibility()
  }

  updateLanguageDropdownVisibility() {
    const isExpanded = this.inputTarget.classList.contains("expanded")
    const isSmallScreen = window.innerWidth <= 450

    if (isExpanded && isSmallScreen) {
      this.dropdown.classList.add("hidden")
    } else {
      setTimeout(() => {
        this.dropdown.classList.remove("hidden")
      }, 200)
    }
  }
}
